/* COD Premium theme — vanilla JS, no dependencies. */
(() => {
  'use strict';
  const T = window.CODTheme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Money ---------- */
  function formatMoney(cents, format = T.moneyFormat || '{{amount}}') {
    cents = Math.round(Number(cents) || 0);
    const fmt = (n, d, ts = ',', ds = '.') => {
      const [i, f] = (n / 100).toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fmt(cents, 2), amount_no_decimals: fmt(cents, 0),
      amount_with_comma_separator: fmt(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_apostrophe_separator: fmt(cents, 2, "'", '.'), amount_with_space_separator: fmt(cents, 2, ' ', ',')
    }[k] ?? fmt(cents, 2)));
  }

  /* ---------- Tracking (single fire per event, only if pixels exist) ---------- */
  const fired = new Set();
  function track(name, data, onceKey) {
    if (onceKey) { if (fired.has(onceKey)) return; fired.add(onceKey); }
    // Shopify Customer Events / Web Pixels already capture standard storefront events.
    // These custom events let Meta/TikTok/GA4 pixels installed via apps or Customer Events react without duplicates.
    try { window.Shopify?.analytics?.publish?.(`cod_${name}`, data); } catch (e) {}
    document.dispatchEvent(new CustomEvent(`cod:${name}`, { detail: data }));
  }

  /* ---------- Header / announcement ---------- */
  const menu = $('[data-menu]');
  $('[data-menu-open]')?.addEventListener('click', e => { menu.classList.add('is-open'); e.currentTarget.setAttribute('aria-expanded', 'true'); });
  $('[data-menu-close]')?.addEventListener('click', () => { menu.classList.remove('is-open'); $('[data-menu-open]')?.setAttribute('aria-expanded', 'false'); });
  const ann = $$('.announcement__item');
  if (ann.length > 1) { let i = 0; setInterval(() => { ann[i].classList.remove('is-active'); i = (i + 1) % ann.length; ann[i].classList.add('is-active'); }, 4000); }
  $('[data-sort]')?.addEventListener('change', e => { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); location.href = u; });

  /* ---------- Cart helpers ---------- */
  async function cartAdd(items) {
    const r = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || T.strings.server);
    const cart = await fetch(T.routes.cart + '.js').then(r => r.json());
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    return data;
  }

  /* ---------- Phone rules per country ---------- */
  const PHONE = {
    MA: { prefix: '+212', re: /^(?:\+?212|0)?([5-7]\d{8})$/ },
    DZ: { prefix: '+213', re: /^(?:\+?213|0)?([5-7]\d{8})$/ },
    TN: { prefix: '+216', re: /^(?:\+?216)?([2-9]\d{7})$/ },
    SA: { prefix: '+966', re: /^(?:\+?966|0)?(5\d{8})$/ },
    AE: { prefix: '+971', re: /^(?:\+?971|0)?(5\d{8})$/ },
    EG: { prefix: '+20', re: /^(?:\+?20|0)?(1[0125]\d{8})$/ },
    FR: { prefix: '+33', re: /^(?:\+?33|0)?([67]\d{8})$/ },
    SN: { prefix: '+221', re: /^(?:\+?221)?(7\d{8})$/ },
    CI: { prefix: '+225', re: /^(?:\+?225)?(0\d{9})$/ }
  };
  function normalizePhone(raw, country) {
    const clean = String(raw).replace(/[\s.\-()]/g, '');
    const rule = PHONE[country];
    if (!rule) return /^\+?\d{8,15}$/.test(clean) ? clean : null;
    const m = clean.match(rule.re);
    return m ? rule.prefix + m[1] : null;
  }

  /* ---------- Product section ---------- */
  $$('[data-product-section]').forEach(initProduct);

  function initProduct(root) {
    const product = JSON.parse($('[data-product-json]', root).textContent);
    let variant = product.variants.find(v => String(v.id) === new URL(location.href).searchParams.get('variant')) || product.variants.find(v => v.available) || product.variants[0];
    const form = $('[data-cod-form]', root);
    const getBundleQty = () => Number($('[data-bundle-qty]:checked', root)?.value || 1);

    track('view_item', { id: product.id, variant: variant.id, price: variant.price }, 'view-' + product.id);

    /* Gallery */
    const trackEl = $('[data-gallery-track]', root);
    const thumbs = $$('[data-thumb]', root);
    thumbs.forEach(t => t.addEventListener('click', () => trackEl.scrollTo({ left: trackEl.clientWidth * Number(t.dataset.thumb), behavior: 'smooth' })));
    trackEl?.addEventListener('scroll', () => {
      const i = Math.round(trackEl.scrollLeft / trackEl.clientWidth);
      thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
    }, { passive: true });
    const dlg = $('[data-zoom-dialog]', root);
    $$('[data-zoom]', root).forEach(b => b.addEventListener('click', () => { $('[data-zoom-img]', dlg).src = b.dataset.zoom; dlg.showModal(); }));
    $('[data-zoom-close]', root)?.addEventListener('click', () => dlg.close());
    dlg?.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });

    /* Variants */
    const radios = $$('[data-option-index]', root);
    function markAvailability() {
      const sel = product.options.map((_, i) => $(`[data-option-index="${i}"]:checked`, root)?.value);
      radios.forEach(r => {
        const i = Number(r.dataset.optionIndex);
        const test = sel.slice(); test[i] = r.value;
        const ok = product.variants.some(v => v.available && v.options.every((o, k) => o === test[k]));
        r.closest('.pill')?.classList.toggle('is-unavailable', !ok);
      });
    }
    radios.forEach(r => r.addEventListener('change', () => {
      const sel = product.options.map((_, i) => $(`[data-option-index="${i}"]:checked`, root)?.value);
      const found = product.variants.find(v => v.options.every((o, i) => o === sel[i]));
      $$('[data-option-label]', root).forEach(l => { l.textContent = sel[Number(l.dataset.optionLabel)]; });
      if (found) setVariant(found);
      markAvailability();
    }));
    markAvailability();

    function setVariant(v) {
      variant = v;
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-price]', root).forEach(el => el.textContent = formatMoney(v.price));
      $$('[data-compare]', root).forEach(el => { el.hidden = !onSale; el.textContent = onSale ? formatMoney(v.compare_at_price) : ''; });
      $$('[data-discount]', root).forEach(el => { el.hidden = !onSale; if (onSale) el.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; });
      $$('[data-price-wrap]', root).forEach(el => el.classList.toggle('price--sale', !!onSale));
      const stock = $('[data-stock]', root);
      if (stock) stock.innerHTML = v.available ? '<span class="stock__dot"></span>' + (stock.dataset.inStock || '✓') : '<span class="stock__dot stock__dot--out"></span>' + T.strings.soldOut;
      $$('[data-buy-now],[data-add-to-cart]', root).forEach(b => b.disabled = !v.available);
      $$('[data-sticky-price]', root).forEach(el => el.textContent = formatMoney(v.price));
      if (v.featured_media) {
        const idx = product.media.findIndex(m => m.id === v.featured_media.id);
        if (idx >= 0 && trackEl) trackEl.scrollTo({ left: trackEl.clientWidth * idx, behavior: 'smooth' });
      }
      if (form) {
        const line = $('[data-line]', form);
        $('[data-line-variant-id]', line).value = v.id;
        $('[data-line-variant]', line).textContent = product.variants.length > 1 ? v.title : '';
        updateSummary();
      }
      updateBundlePrices();
    }

    /* Bundle */
    function updateBundlePrices() {
      $$('[data-bundle-price]', root).forEach(el => el.textContent = formatMoney(variant.price * Number(el.dataset.bundlePrice)));
    }
    updateBundlePrices();
    $$('[data-bundle-qty]', root).forEach(r => r.addEventListener('change', () => {
      if (form) { $('[data-line-qty]', form).value = getBundleQty(); updateSummary(); }
    }));

    /* Countdown: only shows for a real future end date, hides after expiry */
    $$('[data-countdown]', root).forEach(el => {
      const end = new Date(el.dataset.countdown).getTime();
      if (!end || isNaN(end)) return;
      const out = $('[data-countdown-value]', el);
      const tick = () => {
        const d = end - Date.now();
        if (d <= 0) { el.hidden = true; clearInterval(iv); return; }
        el.hidden = false;
        const h = Math.floor(d / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
        out.textContent = (h > 47 ? Math.floor(h / 24) + 'j ' + (h % 24) + 'h ' : String(h).padStart(2, '0') + ':') + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      };
      const iv = setInterval(tick, 1000); tick();
    });

    /* Mode A: buy now / add to cart */
    const buyErr = $('[data-buy-error]', root);
    const showBuyErr = msg => { if (buyErr) { buyErr.textContent = msg; buyErr.hidden = !msg; } };
    async function addCurrent(btn, thenCheckout) {
      if (btn.dataset.busy) return;
      btn.dataset.busy = '1'; btn.disabled = true; showBuyErr('');
      try {
        const qty = getBundleQty();
        await cartAdd([{ id: variant.id, quantity: qty }]);
        track('add_to_cart', { id: product.id, variant: variant.id, quantity: qty, value: variant.price * qty });
        if (thenCheckout) { track('begin_checkout', { value: variant.price * qty }); location.href = '/checkout'; return; }
        btn.textContent = '✓';
        setTimeout(() => { btn.textContent = T.strings.addToCart; }, 1500);
      } catch (e) { showBuyErr(e.message); }
      finally { delete btn.dataset.busy; btn.disabled = !variant.available; }
    }
    $('[data-buy-now]', root)?.addEventListener('click', e => addCurrent(e.currentTarget, true));
    $('[data-add-to-cart]', root)?.addEventListener('click', e => addCurrent(e.currentTarget, false));

    /* Sticky CTA */
    const sticky = $('[data-sticky-cta]', root);
    const mainCta = $('[data-main-cta]', root);
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      const target = form || mainCta;
      let ctaVisible = true, formVisible = false;
      const update = () => { sticky.hidden = ctaVisible || formVisible; };
      new IntersectionObserver(([e]) => { ctaVisible = e.isIntersecting || e.boundingClientRect.top < 0 && !form; update(); }).observe(mainCta);
      if (form) new IntersectionObserver(([e]) => { formVisible = e.isIntersecting; update(); }).observe(form);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => {
        if (form) { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); setTimeout(() => $('input[name="name"]', form)?.focus({ preventScroll: true }), 500); }
        else mainCta.click();
      });
    }
    $('[data-scroll-to-form]', root)?.addEventListener('click', e => {
      e.preventDefault(); form?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      track('begin_checkout', { id: product.id, value: variant.price }, 'begin-' + product.id);
    });

    /* Related products (Shopify recommendations API) */
    const rel = root.parentElement.querySelector('[data-related]') || $('[data-related]');
    if (rel && !rel.dataset.loaded) {
      rel.dataset.loaded = '1';
      fetch(rel.dataset.url).then(r => r.text()).then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.shopify-section');
        if (inner && inner.querySelector('.card')) rel.innerHTML = inner.innerHTML;
      }).catch(() => {});
    }

    if (form) initCodForm(form, root, product, () => variant);
    function updateSummary() { form?._updateSummary?.(); }
  }

  /* ---------- Mode B: COD form ---------- */
  function initCodForm(form, root, product, getVariant) {
    const success = $('[data-cod-success]', root);
    const submit = $('[data-submit]', form);
    const label = $('[data-submit-label]', form);
    const labelText = label.textContent;
    const formErr = $('[data-form-error]', form);
    const country = $('[data-country]', form);
    const prefix = $('[data-phone-prefix]', form);
    const qtyInput = $('[data-line-qty]', form);
    const maxQty = Number(qtyInput.max) || 10;
    let submitting = false;
    let idempotencyKey = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random();
    const storageKey = 'cod-form-' + product.id;

    // Restore saved inputs (kept on error / reload)
    try {
      const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
      ['name', 'phone', 'city', 'address', 'notes', 'country'].forEach(k => { if (saved[k] && form.elements[k]) form.elements[k].value = saved[k]; });
    } catch (e) {}
    form.addEventListener('input', () => {
      const d = {}; ['name', 'phone', 'city', 'address', 'notes', 'country'].forEach(k => { if (form.elements[k]) d[k] = form.elements[k].value; });
      try { sessionStorage.setItem(storageKey, JSON.stringify(d)); } catch (e) {}
    });

    const setPrefix = () => { prefix.textContent = PHONE[country.value]?.prefix || ''; };
    country.addEventListener('change', setPrefix); setPrefix();

    function summary() {
      const v = getVariant();
      const q = Math.min(Math.max(parseInt(qtyInput.value, 10) || 1, 1), maxQty);
      const sub = v.price * q;
      const free = T.freeShippingThreshold > 0 && sub >= T.freeShippingThreshold;
      const ship = free ? 0 : (T.shippingFee || 0);
      $('[data-sum-subtotal]', form).textContent = formatMoney(sub);
      $('[data-sum-shipping]', form).textContent = formatMoney(ship);
      $('[data-sum-total]', form).textContent = formatMoney(sub + ship);
      return { q, sub, ship, total: sub + ship };
    }
    form._updateSummary = summary; summary();

    $('[data-qty-minus]', form).addEventListener('click', () => { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); summary(); });
    $('[data-qty-plus]', form).addEventListener('click', () => { qtyInput.value = Math.min(maxQty, (parseInt(qtyInput.value, 10) || 1) + 1); summary(); });
    qtyInput.addEventListener('change', summary);

    function setErr(name, msg) {
      const el = $(`[data-error-for="${name}"]`, form);
      if (el) el.textContent = msg || '';
      form.elements[name]?.closest('.field')?.classList.toggle('has-error', !!msg);
      form.elements[name]?.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }
    function validate() {
      let ok = true, first = null;
      const fail = (n, m) => { setErr(n, m); ok = false; first = first || form.elements[n]; };
      ['name', 'phone', 'city', 'address'].forEach(n => setErr(n, ''));
      const name = form.elements.name.value.trim();
      if (name.length < 3) fail('name', T.strings.required);
      if (!form.elements.phone.value.trim()) fail('phone', T.strings.required);
      else if (!normalizePhone(form.elements.phone.value, country.value)) fail('phone', T.strings.phone);
      if (!form.elements.city.value.trim()) fail('city', T.strings.required);
      if (form.elements.address.value.trim().length < 3) fail('address', T.strings.required);
      if (first) first.focus();
      return ok;
    }
    ['name', 'phone', 'city', 'address'].forEach(n => form.elements[n]?.addEventListener('blur', () => { if (form.elements[n].value) validate(); }));

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (submitting) return;                       // double-click / repeat protection
      formErr.hidden = true;
      if (form.elements.website.value) return;      // honeypot
      if (!validate()) return;
      const useSheets = T.orderMode === 'sheets';
      const endpoint = useSheets ? T.sheetsUrl : T.codEndpoint;
      if (!endpoint) { formErr.textContent = 'URL d\'envoi non configurée (Paramètres du thème > Commande).'; formErr.hidden = false; return; }

      const v = getVariant();
      if (!v.available) { formErr.textContent = T.strings.soldOut; formErr.hidden = false; return; }
      const s = summary();
      const payload = {
        idempotency_key: idempotencyKey,
        customer: { name: form.elements.name.value.trim(), phone: normalizePhone(form.elements.phone.value, country.value), country: country.value, city: form.elements.city.value.trim(), address: form.elements.address.value.trim(), notes: form.elements.notes?.value.trim() || '' },
        line_items: [{ product_id: product.id, variant_id: v.id, title: product.title, variant_title: v.title, quantity: s.q, unit_price: v.price }],
        currency: form.elements.currency.value,
        displayed: { subtotal: s.sub, shipping: s.ship, total: s.total },
        source_url: location.href
      };

      submitting = true; submit.disabled = true; submit.classList.add('is-loading'); label.textContent = T.strings.sending;
      track('begin_checkout', { value: s.total, currency: payload.currency }, 'begin-' + product.id);
      try {
        const ctrl = new AbortController(); const to = setTimeout(() => ctrl.abort(), 20000);
        const res = useSheets
          // text/plain = simple request (no CORS preflight), which Google Apps Script accepts.
          ? await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload), redirect: 'follow', signal: ctrl.signal })
          : await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'Idempotency-Key': idempotencyKey }, body: JSON.stringify(payload), signal: ctrl.signal });
        clearTimeout(to);
        const data = await res.json().catch(() => ({}));
        // Only a positive response that includes an order identifier counts as a confirmed order.
        if (!res.ok || !data.ok || !(data.order_id || data.order_name)) {
          if (data.errors && typeof data.errors === 'object') Object.entries(data.errors).forEach(([k, m]) => setErr(k, String(m)));
          throw new Error(data.message || T.strings.server);
        }
        track('purchase', { order_id: data.order_id, value: data.total ?? s.total, currency: payload.currency }, 'purchase-' + (data.order_id || data.order_name));
        try { sessionStorage.removeItem(storageKey); sessionStorage.setItem('cod-last-order', data.order_name || data.order_id); } catch (e) {}
        document.dispatchEvent(new CustomEvent('cod:order-success', { detail: data }));
        idempotencyKey = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now());
        if (T.thankYouUrl) { location.href = T.thankYouUrl + '?order=' + encodeURIComponent(data.order_name || data.order_id); return; }
        form.hidden = true; success.hidden = false;
        $('[data-order-ref]', success).textContent = data.order_name ? '#' + String(data.order_name).replace(/^#/, '') : '';
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
        $('[data-sticky-cta]', root)?.setAttribute('hidden', '');
      } catch (err) {
        formErr.textContent = err.name === 'AbortError' || err instanceof TypeError ? T.strings.network : err.message;
        formErr.hidden = false;
      } finally {
        submitting = false; submit.disabled = false; submit.classList.remove('is-loading'); label.textContent = labelText;
      }
    });
  }

  /* Thank-you page reference */
  const ref = $('[data-thank-you-ref]');
  if (ref) { const o = new URL(location.href).searchParams.get('order'); if (o) ref.textContent = '#' + o.replace(/^#/, '').slice(0, 30); }
})();
